import { Text } from '@/components/ui/Text';

export function DiscountCodeError({ message }: { message: string }) {
  return (
    <div className='flex items-center rounded-[6px] bg-[#FFE1E2] p-4'>
      <Text variant='body'>{message}</Text>
    </div>
  );
}
